import { URLQueries, getUrlBizExtraParams } from '../global_env/url_query'
import { GlobalEnv } from '../global_env'
import { getTrackUrl, getBizExtraData } from '../../js/util'
import { is, trackEvent, xenv } from '@didi/webx-js'
export const mallTrack = (key, name, params) => {
  trackEvent(
    key,
    name,
    Object.assign(params, {
      lang: GlobalEnv.lang,
      fr: xenv(),
      source: getTrackUrl(),
    })
  )
}

const getPubType = () => {
  switch (true) {
    case !!is('passenger'):
      return 'na'
    case !!is('weixin'):
      return 'weixin'
    case !!is('alipay'):
      return 'alipay'
    case !!is('douyin'):
      return 'dy'
    default:
      return 'others'
  }
}

const PubType = getPubType()

export const mallTrackStd = (key, name, params = {}) => {
  // console.log('-mallTrackStd', key, name, params)
  const adParams = getUrlBizExtraParams()
  const { trackExtraParams } = getBizExtraData()
  const extraInfo = Object.assign({}, adParams, trackExtraParams)
  trackEvent(
    key,
    name,
    Object.assign(params, {
      uid: GlobalEnv.loginInfo.uid,
      dchn: URLQueries.getQuery('dchn'),
      channel_id: GlobalEnv.channelId,
      pub_type: PubType,
      xcx_openid: URLQueries.getQuery('openid'),
      extra: extraInfo,
    })
  )
}
